import ApiService from '@/core/services/api.service';

const BASE_URL = 'leads';

const LeadService = {
  getAll(params = {}) {
    return ApiService.query(`${BASE_URL}`, { params });
  },

  getById(id) {
    return ApiService.query(`${BASE_URL}/${id}`);
  },

  create(data) {
    return ApiService.post(`${BASE_URL}`, data);
  },

  update(id, data) {
    return ApiService.put(`${BASE_URL}/${id}`, data);
  },

  delete(id) {
    return ApiService.delete(`${BASE_URL}/${id}`);
  },

  exportExcel(params = {}) {
    return ApiService.query(`${BASE_URL}/export-excel`, {
      params,
      responseType: 'blob',
    });
  },

  importExcel(data) {
    return ApiService.post(`${BASE_URL}/import-excel`, { data });
  },

  bulkCreate(data) {
    return ApiService.post(`${BASE_URL}/bulks`, { data });
  },

  // Lead Product specific operations
  updateLeadProducts(leadId, products) {
    return ApiService.put(`${BASE_URL}/${leadId}/products`, { products });
  },

  convertToCustomer(customerType, lead) {
    return ApiService.post(`${BASE_URL}/convert-to-customer`, {
      customerType,
      leadData: lead,
    });
  },
};

export default LeadService;
